import { useDispatch } from 'react-redux';
import { Link, useMatch } from 'react-router-dom';

import { clearNotification } from '../../../../store/notification';
import { TRACK_LIST_BREADCRUMB_TEST_ID } from './Breadcrumb.test-ids';

import styles from './Breadcrumb.module.scss';

const Breadcrumb: React.FC = () => {
  const matchDetails = useMatch('/details/*');
  const dispatch = useDispatch();

  if (!matchDetails) return null;
  return (
    <div className={styles.breadcrumbContainer}>
      <div className={styles.breadcrumb}>
        <Link
          to='/'
          className={styles.backLink}
          data-testid={TRACK_LIST_BREADCRUMB_TEST_ID}
          onClick={() => dispatch(clearNotification())}
        >
          Tracking
        </Link>
      </div>
    </div>
  );
};

export default Breadcrumb;
